import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers } from "vue"

import { computed } from "vue";
import { ArtifactNodeDisplayProps } from "@/types";
import { getEnumColor } from "@/util";
import { deltaStore, viewsStore } from "@/hooks";
import { NodeDisplay } from "@/components/graph/display";
import { FlexBox, Icon, Typography, Separator } from "@/components/common";


/**
 * Renders the footer of an artifact node in the graph, when child artifacts are hidden.
 */
const __default__ = {
  name: "ArtifactNodeFooter",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    color: {},
    selected: { type: Boolean },
    hiddenChildren: {},
    artifact: {}
  },
  setup(__props: any) {

const props = __props;

const hiddenChildrenLabel = computed(() =>
  props.hiddenChildren.length === 1
    ? "1 Hidden"
    : `${props.hiddenChildren.length} Hidden`
);
const showHiddenChildren = computed(() => props.hiddenChildren.length > 0);

const hiddenChildDeltaStates = computed(() =>
  deltaStore.getArtifactDeltaStates(props.hiddenChildren)
);
const showDelta = computed(() => deltaStore.inDeltaView);
const deltaClassName = computed(() =>
  showDelta.value && props.hiddenChildren.length > 0
    ? "cy-node-delta-footer"
    : ""
);
const childDeltaColors = computed(() =>
  hiddenChildDeltaStates.value.map(getEnumColor)
);

return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!

  return (showHiddenChildren.value)
    ? (_openBlock(), _createBlock(_unref(NodeDisplay), {
        key: 0,
        color: props.color,
        variant: "footer",
        selected: props.selected,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(viewsStore).extendDocumentSubtree(props.artifact))),
        onMousedown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
        onMouseup: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(FlexBox), {
            align: "center",
            justify: "center",
            class: _normalizeClass(deltaClassName.value)
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Icon), {
                variant: "down",
                size: "sm"
              }),
              _createVNode(_unref(Typography), { value: hiddenChildrenLabel.value }, null, 8, ["value"])
            ]),
            _: 1
          }, 8, ["class"]),
          (showDelta.value)
            ? (_openBlock(), _createBlock(_unref(FlexBox), {
                key: 0,
                class: "cy-node-delta-chip"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(childDeltaColors.value, (childColor) => {
                    return (_openBlock(), _createBlock(_unref(Separator), {
                      key: childColor,
                      color: childColor,
                      class: "cy-node-delta-child-chip"
                    }, null, 8, ["color"]))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_q_tooltip, { delay: 300 }, {
            default: _withCtx(() => [
              _createTextVNode("Show children")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["color", "selected"]))
    : _createCommentVNode("", true)
}
}

})